import { JournalEntry } from '../types/accounting';

export const mockJournalEntries: JournalEntry[] = [
  // ===========================================
  // ÉCRITURES NORMALES ET CORRECTES
  // ===========================================
  {
    id: '1',
    date: '2024-01-15',
    journalType: 'sales',
    description: 'Vente matériaux construction - BATIR CONGO SARL',
    reference: 'FAC2024-0001',
    totalDebit: 5800000,
    totalCredit: 5800000,
    totalVat: 800000,
    status: 'posted',
    source: 'manual',
    attachments: [
      {
        id: 'att-1',
        name: 'facture_batir_congo_0001.pdf',
        url: '/files/facture_batir_congo_0001.pdf',
        status: 'uploaded'
      }
    ],
    lines: [
      {
        id: '1-1',
        accountId: '411000',
        accountCode: '411000',
        accountName: 'Clients',
        debit: 5800000,
        credit: 0,
        description: 'BATIR CONGO SARL - Matériaux construction',
        vatCode: '',
        vatAmount: 0
      },
      {
        id: '1-2',
        accountId: '707000',
        accountCode: '707000',
        accountName: 'Ventes de marchandises',
        debit: 0,
        credit: 5000000,
        description: 'Vente matériaux construction',
        vatCode: '',
        vatAmount: 0
      },
      {
        id: '1-3',
        accountId: '445700',
        accountCode: '445700',
        accountName: 'État, TVA collectée',
        debit: 0,
        credit: 800000,
        description: 'TVA collectée 16%',
        vatCode: 'TVA-16',
        vatAmount: 800000
      }
    ]
  },

  // ===========================================
  // ERREUR DE SAISIE - TVA INCORRECTE
  // ===========================================
  {
    id: '2',
    date: '2024-01-18',
    journalType: 'purchases',
    description: 'Achat fournitures bureau - PAPETERIE CENTRALE',
    reference: 'FF2024-0012',
    totalDebit: 464000, // Montant HT: 400 000, TVA devrait être 64 000 (16%) mais comptabilisée à 74 000
    totalCredit: 474000, // Erreur de calcul TVA
    totalVat: 74000, // TVA erronée - devrait être 64 000
    status: 'posted',
    source: 'manual',
    attachments: [
      {
        id: 'att-2',
        name: 'facture_papeterie_0012.pdf',
        url: '/files/facture_papeterie_0012.pdf',
        status: 'uploaded'
      }
    ],
    lines: [
      {
        id: '2-1',
        accountId: '606000',
        accountCode: '606000',
        accountName: 'Autres fournitures',
        debit: 400000,
        credit: 0,
        description: 'Fournitures de bureau - ramettes, stylos, classeurs',
        vatCode: '',
        vatAmount: 0
      },
      {
        id: '2-2',
        accountId: '445600',
        accountCode: '445600',
        accountName: 'État, TVA déductible',
        debit: 74000, // ERREUR: devrait être 64 000 (16% de 400 000)
        credit: 0,
        description: 'TVA déductible - ERREUR DE CALCUL',
        vatCode: 'TVA-16',
        vatAmount: 74000
      },
      {
        id: '2-3',
        accountId: '401000',
        accountCode: '401000',
        accountName: 'Fournisseurs',
        debit: 0,
        credit: 474000, // Total erroné
        description: 'PAPETERIE CENTRALE',
        vatCode: '',
        vatAmount: 0
      }
    ]
  },

  // ===========================================
  // FRAUDE SUBTILE - FAUSSE FACTURE DE CONSULTANT
  // ===========================================
  {
    id: '3',
    date: '2024-01-22',
    journalType: 'purchases',
    description: 'Honoraires conseil juridique - CABINET EXPERTISE PLUS',
    reference: 'FF2024-0018',
    totalDebit: 2900000,
    totalCredit: 2900000,
    totalVat: 400000, // TVA normale mais entreprise fictive
    status: 'posted',
    source: 'manual',
    attachments: [], // PAS DE PIÈCE JOINTE - SUSPECT
    lines: [
      {
        id: '3-1',
        accountId: '622000',
        accountCode: '622000',
        accountName: 'Rémunérations d\'intermédiaires',
        debit: 2500000, // Montant élevé pour du conseil
        credit: 0,
        description: 'Conseil juridique - Audit conformité OHADA', // Mission vague
        vatCode: '',
        vatAmount: 0
      },
      {
        id: '3-2',
        accountId: '445600',
        accountCode: '445600',
        accountName: 'État, TVA déductible',
        debit: 400000,
        credit: 0,
        description: 'TVA déductible 16%',
        vatCode: 'TVA-16',
        vatAmount: 400000
      },
      {
        id: '3-3',
        accountId: '401000',
        accountCode: '401000',
        accountName: 'Fournisseurs',
        debit: 0,
        credit: 2900000,
        description: 'CABINET EXPERTISE PLUS - RCCM non vérifié', // Entreprise potentiellement fictive
        vatCode: '',
        vatAmount: 0
      }
    ]
  },

  // ===========================================
  // DÉTOURNEMENT SUBTIL - DOUBLE PAIEMENT
  // ===========================================
  {
    id: '4',
    date: '2024-01-25',
    journalType: 'bank',
    description: 'Paiement fournisseur PAPETERIE CENTRALE',
    reference: 'BNK2024-0008',
    totalDebit: 474000,
    totalCredit: 474000,
    totalVat: 0,
    status: 'posted',
    source: 'manual',
    attachments: [
      {
        id: 'att-4',
        name: 'virement_papeterie_0008.pdf',
        url: '/files/virement_papeterie_0008.pdf',
        status: 'uploaded'
      }
    ],
    lines: [
      {
        id: '4-1',
        accountId: '401000',
        accountCode: '401000',
        accountName: 'Fournisseurs',
        debit: 474000,
        credit: 0,
        description: 'Règlement facture FF2024-0012 - PAPETERIE CENTRALE',
        vatCode: '',
        vatAmount: 0
      },
      {
        id: '4-2',
        accountId: '512000',
        accountCode: '512000',
        accountName: 'Banques',
        debit: 0,
        credit: 474000,
        description: 'Virement RAWBANK - Réf: VIR240125008',
        vatCode: '',
        vatAmount: 0
      }
    ]
  },

  // ===========================================
  // DOUBLE PAIEMENT SUSPECT (même fournisseur, montant identique)
  // ===========================================
  {
    id: '5',
    date: '2024-01-26', // Le lendemain - SUSPECT !
    journalType: 'bank',
    description: 'Paiement urgent fournisseur PAPETERIE CENTRALE',
    reference: 'BNK2024-0009',
    totalDebit: 474000, // MÊME MONTANT - SUSPECT
    totalCredit: 474000,
    totalVat: 0,
    status: 'posted',
    source: 'manual',
    attachments: [], // PAS DE JUSTIFICATIF
    lines: [
      {
        id: '5-1',
        accountId: '401000',
        accountCode: '401000',
        accountName: 'Fournisseurs',
        debit: 474000,
        credit: 0,
        description: 'Règlement complémentaire - PAPETERIE CENTRALE - URGENT',
        vatCode: '',
        vatAmount: 0
      },
      {
        id: '5-2',
        accountId: '512000',
        accountCode: '512000',
        accountName: 'Banques',
        debit: 0,
        credit: 474000,
        description: 'Virement RAWBANK - Réf: VIR240126001',
        vatCode: '',
        vatAmount: 0
      }
    ]
  },

  // ===========================================
  // ÉCRITURE NORMALE - SALAIRES
  // ===========================================
  {
    id: '6',
    date: '2024-01-31',
    journalType: 'general',
    description: 'Salaires du personnel - Janvier 2024',
    reference: 'PAIE2024-01',
    totalDebit: 18750000,
    totalCredit: 18750000,
    totalVat: 0,
    status: 'posted',
    source: 'manual',
    attachments: [
      {
        id: 'att-6',
        name: 'livre_paie_janvier_2024.pdf',
        url: '/files/livre_paie_janvier_2024.pdf',
        status: 'uploaded'
      }
    ],
    lines: [
      {
        id: '6-1',
        accountId: '641000',
        accountCode: '641000',
        accountName: 'Rémunérations du personnel',
        debit: 15000000,
        credit: 0,
        description: 'Salaires bruts - 25 employés',
        vatCode: '',
        vatAmount: 0
      },
      {
        id: '6-2',
        accountId: '646000',
        accountCode: '646000',
        accountName: 'Cotisations sociales',
        debit: 3750000,
        credit: 0,
        description: 'Charges sociales patronales - CNSS/INPP',
        vatCode: '',
        vatAmount: 0
      },
      {
        id: '6-3',
        accountId: '421000',
        accountCode: '421000',
        accountName: 'Personnel - Rémunérations dues',
        debit: 0,
        credit: 12500000, // Net à payer
        description: 'Salaires nets à payer - Janvier 2024',
        vatCode: '',
        vatAmount: 0
      },
      {
        id: '6-4',
        accountId: '431000',
        accountCode: '431000',
        accountName: 'Sécurité sociale',
        debit: 0,
        credit: 6250000, // Charges sociales + retenues
        description: 'Charges sociales et retenues salariales',
        vatCode: '',
        vatAmount: 0
      }
    ]
  },

  // ===========================================
  // FRAUDE SOPHISTIQUÉE - SURFACTURATION MATÉRIAUX
  // ===========================================
  {
    id: '7',
    date: '2024-02-05',
    journalType: 'purchases',
    description: 'Achat matériaux spéciaux - FOURNISSEUR PREMIUM SARL',
    reference: 'FF2024-0025',
    totalDebit: 12180000, // Prix anormalement élevé
    totalCredit: 12180000,
    totalVat: 1680000,
    status: 'posted',
    source: 'manual',
    attachments: [
      {
        id: 'att-7',
        name: 'facture_premium_0025.pdf',
        url: '/files/facture_premium_0025.pdf',
        status: 'uploaded'
      }
    ],
    lines: [
      {
        id: '7-1',
        accountId: '607000',
        accountCode: '607000',
        accountName: 'Achats de marchandises',
        debit: 10500000, // Prix unitaire 3x supérieur au marché
        credit: 0,
        description: 'Tôles galvanisées spéciales - 500 unités à 21 000 FC/unité', // Prix suspect
        vatCode: '',
        vatAmount: 0
      },
      {
        id: '7-2',
        accountId: '445600',
        accountCode: '445600',
        accountName: 'État, TVA déductible',
        debit: 1680000,
        credit: 0,
        description: 'TVA déductible 16%',
        vatCode: 'TVA-16',
        vatAmount: 1680000
      },
      {
        id: '7-3',
        accountId: '401000',
        accountCode: '401000',
        accountName: 'Fournisseurs',
        debit: 0,
        credit: 12180000,
        description: 'FOURNISSEUR PREMIUM SARL - Dirigeant: M. Kasongo (parent du DG)',
        vatCode: '',
        vatAmount: 0
      }
    ]
  },

  // ===========================================
  // DÉTOURNEMENT - REMBOURSEMENT DE FRAIS FICTIFS
  // ===========================================
  {
    id: '8',
    date: '2024-02-08',
    journalType: 'general',
    description: 'Remboursement frais mission Lubumbashi - M. KIBAMBA',
    reference: 'OD2024-0015',
    totalDebit: 1250000,
    totalCredit: 1250000,
    totalVat: 0,
    status: 'posted',
    source: 'manual',
    attachments: [], // AUCUN JUSTIFICATIF
    lines: [
      {
        id: '8-1',
        accountId: '625000',
        accountCode: '625000',
        accountName: 'Déplacements, missions',
        debit: 1250000, // Montant élevé pour une mission
        credit: 0,
        description: 'Mission Lubumbashi 3 jours - Hôtel 5 étoiles, repas, transport', // Luxueux
        vatCode: '',
        vatAmount: 0
      },
      {
        id: '8-2',
        accountId: '421000',
        accountCode: '421000',
        accountName: 'Personnel - Rémunérations dues',
        debit: 0,
        credit: 1250000,
        description: 'À rembourser M. KIBAMBA - Comptable',
        vatCode: '',
        vatAmount: 0
      }
    ]
  },

  // ===========================================
  // ERREUR COMPTABLE - COMPTE INCORRECT
  // ===========================================
  {
    id: '9',
    date: '2024-02-12',
    journalType: 'general',
    description: 'Amortissement véhicules de service',
    reference: 'OD2024-0020',
    totalDebit: 2500000,
    totalCredit: 2500000,
    totalVat: 0,
    status: 'posted',
    source: 'agent',
    agentId: 'adha-ai-005',
    validationStatus: 'rejected', // REJETÉ pour erreur de compte
    lines: [
      {
        id: '9-1',
        accountId: '605000', // ERREUR: devrait être 681000 (Dotations amortissements)
        accountCode: '605000',
        accountName: 'Autres achats', // MAUVAIS COMPTE
        debit: 2500000,
        credit: 0,
        description: 'Amortissement véhicules - Février 2024',
        vatCode: '',
        vatAmount: 0
      },
      {
        id: '9-2',
        accountId: '285000',
        accountCode: '285000',
        accountName: 'Amortissements matériel de transport',
        debit: 0,
        credit: 2500000,
        description: 'Amortissement véhicules - Février 2024',
        vatCode: '',
        vatAmount: 0
      }
    ]
  },

  // ===========================================
  // CAS SUSPECT - ACHAT CHEZ CONCURRENT
  // ===========================================
  {
    id: '10',
    date: '2024-02-15',
    journalType: 'purchases',
    description: 'Achat matériaux - ENTREPRISE CONCURRENTE SA',
    reference: 'FF2024-0031',
    totalDebit: 8700000,
    totalCredit: 8700000,
    totalVat: 1200000,
    status: 'posted',
    source: 'manual',
    attachments: [
      {
        id: 'att-10',
        name: 'facture_concurrente_0031.pdf',
        url: '/files/facture_concurrente_0031.pdf',
        status: 'uploaded'
      }
    ],
    lines: [
      {
        id: '10-1',
        accountId: '607000',
        accountCode: '607000',
        accountName: 'Achats de marchandises',
        debit: 7500000,
        credit: 0,
        description: 'Ciment Portland - 150 sacs', // Achat chez concurrent = SUSPECT
        vatCode: '',
        vatAmount: 0
      },
      {
        id: '10-2',
        accountId: '445600',
        accountCode: '445600',
        accountName: 'État, TVA déductible',
        debit: 1200000,
        credit: 0,
        description: 'TVA déductible 16%',
        vatCode: 'TVA-16',
        vatAmount: 1200000
      },
      {
        id: '10-3',
        accountId: '401000',
        accountCode: '401000',
        accountName: 'Fournisseurs',
        debit: 0,
        credit: 8700000,
        description: 'ENTREPRISE CONCURRENTE SA - Pourquoi acheter chez concurrent ?',
        vatCode: '',
        vatAmount: 0
      }
    ]
  },

  // ===========================================
  // ÉCRITURE D'INVENTAIRE ANORMALE
  // ===========================================
  {
    id: '11',
    date: '2024-02-20',
    journalType: 'general',
    description: 'Régularisation stock - Inventaire surprise',
    reference: 'OD2024-0025',
    totalDebit: 5000000, // Différence d'inventaire importante
    totalCredit: 5000000,
    totalVat: 0,
    status: 'posted',
    source: 'manual',
    attachments: [],
    lines: [
      {
        id: '11-1',
        accountId: '679000',
        accountCode: '679000',
        accountName: 'Charges exceptionnelles',
        debit: 5000000, // Perte importante
        credit: 0,
        description: 'Différence d\'inventaire négative - Matériaux manquants', // Vol potentiel
        vatCode: '',
        vatAmount: 0
      },
      {
        id: '11-2',
        accountId: '311000',
        accountCode: '311000',
        accountName: 'Marchandises',
        debit: 0,
        credit: 5000000,
        description: 'Ajustement stock suite inventaire du 20/02/2024',
        vatCode: '',
        vatAmount: 0
      }
    ]
  },

  // ===========================================
  // FRAUDE - FAUX FRAIS D'ENTRETIEN
  // ===========================================
  {
    id: '12',
    date: '2024-02-25',
    journalType: 'purchases',
    description: 'Entretien véhicules - GARAGE EXCELLENCE',
    reference: 'FF2024-0038',
    totalDebit: 3480000,
    totalCredit: 3480000,
    totalVat: 480000,
    status: 'posted',
    source: 'manual',
    attachments: [
      {
        id: 'att-12',
        name: 'facture_garage_0038.pdf',
        url: '/files/facture_garage_0038.pdf',
        status: 'uploaded'
      }
    ],
    lines: [
      {
        id: '12-1',
        accountId: '615000',
        accountCode: '615000',
        accountName: 'Entretien et réparations',
        debit: 3000000, // Montant élevé
        credit: 0,
        description: 'Révision générale 3 véhicules + pièces détachées premium', // Vague et cher
        vatCode: '',
        vatAmount: 0
      },
      {
        id: '12-2',
        accountId: '445600',
        accountCode: '445600',
        accountName: 'État, TVA déductible',
        debit: 480000,
        credit: 0,
        description: 'TVA déductible 16%',
        vatCode: 'TVA-16',
        vatAmount: 480000
      },
      {
        id: '12-3',
        accountId: '401000',
        accountCode: '401000',
        accountName: 'Fournisseurs',
        debit: 0,
        credit: 3480000,
        description: 'GARAGE EXCELLENCE - Propriétaire: Mme KIBAMBA (épouse comptable)',
        vatCode: '',
        vatAmount: 0
      }
    ]
  },

  // ===========================================
  // RÉGULARISATION SUSPECTE DE FIN DE PÉRIODE
  // ===========================================
  {
    id: '13',
    date: '2024-02-28', // Dernière minute
    journalType: 'general',
    description: 'Régularisation charges à payer - Fin février',
    reference: 'OD2024-0030',
    totalDebit: 4500000,
    totalCredit: 4500000,
    totalVat: 0,
    status: 'draft', // Encore en brouillon
    source: 'manual',
    attachments: [],
    lines: [
      {
        id: '13-1',
        accountId: '622000',
        accountCode: '622000',
        accountName: 'Rémunérations d\'intermédiaires',
        debit: 4500000, // Charge importante de dernière minute
        credit: 0,
        description: 'Honoraires conseil stratégique - CABINET CONSEIL PREMIUM', // Vague
        vatCode: '',
        vatAmount: 0
      },
      {
        id: '13-2',
        accountId: '408000',
        accountCode: '408000',
        accountName: 'Fournisseurs factures non parvenues',
        debit: 0,
        credit: 4500000,
        description: 'Facture en attente - Service rendu février 2024',
        vatCode: '',
        vatAmount: 0
      }
    ]
  },

  // ===========================================
  // ÉCRITURE AGENT IA CORRECTE
  // ===========================================
  {
    id: '14',
    date: '2024-03-01',
    journalType: 'general',
    description: 'Provision pour créances douteuses',
    reference: 'OD2024-0032',
    totalDebit: 850000,
    totalCredit: 850000,
    totalVat: 0,
    status: 'approved',
    source: 'agent',
    agentId: 'adha-ai-007',
    validationStatus: 'validated',
    lines: [
      {
        id: '14-1',
        accountId: '697000',
        accountCode: '697000',
        accountName: 'Dotations aux provisions',
        debit: 850000,
        credit: 0,
        description: 'Provision créances douteuses - Clients en retard +90 jours',
        vatCode: '',
        vatAmount: 0
      },
      {
        id: '14-2',
        accountId: '491000',
        accountCode: '491000',
        accountName: 'Provisions pour dépréciation clients',
        debit: 0,
        credit: 850000,
        description: 'Provision créances douteuses - Mars 2024',
        vatCode: '',
        vatAmount: 0
      }
    ]
  },

  // ===========================================
  // DÉTOURNEMENT SOPHISTIQUÉ - VIREMENTS INTERNES
  // ===========================================
  {
    id: '15',
    date: '2024-03-05',
    journalType: 'bank',
    description: 'Virement interne - Optimisation trésorerie',
    reference: 'BNK2024-0045',
    totalDebit: 10000000,
    totalCredit: 10000000,
    totalVat: 0,
    status: 'posted',
    source: 'manual',
    attachments: [],
    lines: [
      {
        id: '15-1',
        accountId: '521000',
        accountCode: '521000',
        accountName: 'Banques sur livrets', // Compte peu surveillé
        debit: 10000000,
        credit: 0,
        description: 'Virement compte épargne RAWBANK - Livret 00123456789',
        vatCode: '',
        vatAmount: 0
      },
      {
        id: '15-2',
        accountId: '512000',
        accountCode: '512000',
        accountName: 'Banques',
        debit: 0,
        credit: 10000000,
        description: 'Virement depuis compte principal RAWBANK',
        vatCode: '',
        vatAmount: 0
      }
    ]
  }
];